var setToStringTag = require('../internals/set-to-string-tag');

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/es.math.to-string-tag.js
// module id = 2505
// module chunks = 0